import store from '@/store'
import Base from '../components/ModuleBase'
import WOBase from '../views/woDetail/Base'
import ActionTracker from '../views/actionTracker/WOActionTracker';
import Dashboard from '../views/Dashboard'
import WOsReadyForOffice from '../views/WOsReadyForOffice'
import Overview from '../views/woDetail/Overview'
import WOProductLabour from '../views/woDetail/WOProductLabour';
import WOInstallForm from '../views/woDetail/WOInstallForm';

const routes = [
  {
    path: '/work-orders/',
    component: Base,
    meta: { appKey: 'workorders' },
    children: [
      {
        path: 'dashboard',
        component: Dashboard,
        name: 'WOsDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'wo-detail/:id/',
        component: WOBase,
        children: [
          {
            path: 'overview',
            component: Overview,
            name: 'WOOverview'
          },
          {
            path: 'action-tracker',
            name: 'WOActionTracker',
            component: ActionTracker
          },
          {
            path: 'wo-product-labour',
            name: 'WOProductLabour',
            component: WOProductLabour
          },
          {
            path: 'wo-install-form',
            name: 'WOInstallForm',
            component: WOInstallForm
          }
        ]
      },
      {
        path: 'ready-for-invoice',
        component: WOsReadyForOffice,
        name: 'WOsReadyForOffice',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      }
    ]
  }
]

export default routes
